import { useState, useEffect } from "react";
import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { ANALYTICS_CONSENT_KEY, initialiseAnalytics, setAnalyticsConsent } from "@/lib/analytics";

export function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(ANALYTICS_CONSENT_KEY);
    if (consent === "granted") {
      initialiseAnalytics();
    }
    if (!consent) {
      setShow(true);
    }
  }, []);

  const handleAccept = () => {
    setAnalyticsConsent("granted");
    setShow(false);
  };

  const handleDecline = () => {
    setAnalyticsConsent("denied");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-background border-t border-border shadow-[0_-4px_20px_rgba(0,0,0,0.05)] md:p-6 flex flex-col sm:flex-row items-center justify-between gap-4"
      role="region"
      aria-label="Analytics cookie choices"
    >
      <div className="text-sm text-muted-foreground flex-grow max-w-4xl">
        <p>
          We use optional analytics cookies to understand website traffic. They stay off unless you accept them. Read our <Link href="/cookie-policy" className="text-primary underline underline-offset-2">Cookie Policy</Link> for more details.
        </p>
      </div>
      <div className="flex items-center gap-3 shrink-0">
        <Button variant="outline" onClick={handleDecline} className="font-medium bg-background text-foreground" data-testid="button-cookie-decline">
          Decline Non-Essential
        </Button>
        <Button onClick={handleAccept} className="font-bold" data-testid="button-cookie-accept">
          Accept All
        </Button>
      </div>
    </div>
  );
}
